$(document).ready(function() {
    $(document).on('submit', '.js-product-list div.modal-content form', function(e) {
        var form_el = $(this);
        e.preventDefault();
        $.ajax({
            method: $(this).attr('method'),
            url: $(this).attr('action'),
            data: $(this).serialize(),
            success: function (xhr, ajaxOptions, thrownError) {
                setTimeout(function() {
                    location.reload();  // Refresh page
                }, 500);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                form_el.parent('.modal-content').html(xhr.responseText);
            }
        });
    });

    $('.js-product-list input[name="boots"]').on('change', function(event) {
        var input = $(event.currentTarget);
        // Allow Only One Checkbox to be Checked for boots selection
        $(input).closest('div').find('input:checkbox').not(this).prop('checked', false);
        var summaryPrice = getSummaryPrice(event);
        input.closest('.js-c-box').find('.summary-price--value').text(summaryPrice);
    });

    $('.js-product-list input[name="has_price_upgrade"]').on('change', function(event) {
        var input = $(event.currentTarget);
        var imageSrc = DJANGO.staticPrefix;
        var summaryPrice = getSummaryPrice(event);
        var isChecked = $(input).closest('.js-c-box')
            .find('input[name="has_price_upgrade"]').is(':checked');
        // Change summary price when selected "new ski"
        input.closest('.js-c-box').find('.summary-price--value').text(summaryPrice);
        // Change image of ski according to selected ski(new or used)
        if (isChecked) {
            imageSrc += getProduct(event).image_premium;
        } else {
            imageSrc += getProduct(event).image_basic;
        }
        input.closest('.js-c-box').find('.js-c-box__photo-wrap img').attr('src', imageSrc);
    });

    $('.js-product-list input[name="has_poles"]').on('change', function(event) {
        var input = $(event.currentTarget);
        var summaryPrice = getSummaryPrice(event);
        input.closest('.js-c-box').find('.summary-price--value').text(summaryPrice);
    });

    $('.basketModal form input').keyup(function(event) {

        var empty = false;
        $(event.currentTarget).closest('form').find('input#id_skier_name, input#id_skier_height, input#id_skier_weight').each(function() {
            if ($(this).val() == '') {
                empty = true;
            }
        });

        if (empty) {
            $('.js-c-button__submit').attr('disabled', 'disabled');
        } else {
            $('.js-c-button__submit').removeAttr('disabled');
        }
    });
});

function getProduct(event) {
    var input = $(event.currentTarget);
    var product = input.closest('.js-c-box').data('product');
    return product;
}

function getProductPrice(event) {
    var input = $(event.currentTarget);
    var product = input.closest('.js-c-box').data('product');
    return parseFloat(product.price);
}

function getProductUpgradePrice(event) {
    var input = $(event.currentTarget);
    var product = input.closest('.js-c-box').data('product');
    return $(input).closest('.js-c-box').find('input[name="has_price_upgrade"]')
        .is(':checked') ? parseFloat(product.price_upgrade) : 0;
}

function getBootsPrice(event) {
    var input = $(event.currentTarget);
    var checkedBoots = $(input).closest('.js-c-box').find('input[name="boots"]:checked').first();
    console.log(checkedBoots, checkedBoots.data('price'));
    return checkedBoots.length ? parseFloat(checkedBoots.data('price')) : 0;
}

function getPolesPrice(event) {
    var input = $(event.currentTarget);
    var product = input.closest('.js-c-box').data('product');
    return $(input).closest('.js-c-box').find('input[name="has_poles"]')
        .is(':checked') ? parseFloat(product.poles) : 0;
}

function getSummaryPrice(event) {
    var productPrice = getProductPrice(event);
    var productPriceUpgrade = getProductUpgradePrice(event);
    var bootsPrice = getBootsPrice(event);
    var polesPrice = getPolesPrice(event);
    return productPrice + productPriceUpgrade + bootsPrice + polesPrice;
}



// WEBPACK FOOTER //
// ./private/js/season_rental/product_list.js